var _rect, _path, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 96,
    ry: 96,
    fill: "#059669"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M136 96h240a16 16 0 0 1 16 16v300l-32-26-32 26-32-26-32 26-32-26-32 26-32-26-32 26V112a16 16 0 0 1 16-16z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 152,
    width: 160,
    height: 22,
    rx: 11,
    fill: "#059669"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 204,
    width: 112,
    height: 22,
    rx: 11,
    fill: "#059669",
    opacity: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 256,
    width: 136,
    height: 22,
    rx: 11,
    fill: "#059669",
    opacity: 0.55
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 316,
    width: 160,
    height: 26,
    rx: 13,
    fill: "#0f172a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeLogo);
export default __webpack_public_path__ + "static/media/office-logo.5956debe1fd6a147ecd6c6e7c77e9379.svg";
export { ForwardRef as ReactComponent };